<template>
    <div class="login">
        <div class="background">
            <div class="backgroundimg" :style="height">
                <img src="../../assets/images/login/icon03.jpg" alt="">
            </div>
            <div class="background-text">
                <img src="../../assets/images/login/icon04.png" alt="">

                <div class="main">
                    <div class="title" style="margin-top:50px">恋TA系统</div>
                    <div class="sect">
                        <div class="sect-tit">
                            管理者登录
                        </div>
                        <div class="item">
                            <div class="input">
                                <el-input prefix-icon="el-icon-user-solid" v-model="signInData.userName " placeholder="请输入账户名"></el-input>
                            </div>
                        </div>
                        <div class="item" style="margin-top:15px">
                            <div class="input">
                                <el-input prefix-icon="el-icon-unlock" v-model="signInData.passWord " placeholder="请输入密码"></el-input>
                            </div>
                        </div>
                        <!-- <div class="item" style="margin-top:15px">
                            <div class="input item-input">
                                <el-input prefix-icon="el-icon-key" v-model="imageCode" placeholder="请输入图形验证码"></el-input>
                            </div>
                            <el-image
                                style="width: 112px; height: 40px"
                                :src="imageCodeUrl"
                                fit="cover"
                                @click="getImageCode()">
                            </el-image>
                        </div>
                        <div class="item" style="margin-top:15px">
                            <div class="input item-input">
                                <el-input prefix-icon="el-icon-unlock" v-model="signInData.code" placeholder="请输入密码"></el-input>
                            </div>
                            <el-button type="primary" @click="captchaButtonClick" class="item-btn">{{captchaFont}}</el-button>
                        </div> -->
                        <div class="btn" @click="signIn">登录</div>
                        <!-- <el-button type="primary" class="btn" @click="signIn">登录</el-button> -->
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
import api from '../../api/login'
import {isPhoneNumber } from '../../utils/index'
export default {
    name: 'login',
    data () {
        return {
            height:'',
            signInData:{
                phone:'',
                code:'',
            },

            captchaFont: '获取验证码',
            totalTime: 60,
            timer: null,
            rulesText: '',
            regCodeText:'',

            imageCodeUrl:'',
            imageCode:'',
            fileName:''
        }
    },
    created(){
        

    },
    mounted(){
        if(localStorage.getItem('lianta_accessToken')&&localStorage.getItem('lianta_userData')){
            this.$router.push({ path:'/main' });
        }
        this.getImageCode();
        this.getHeight();
    },
    methods:{
        async getImageCode(){
            let res = await api.getImageCode();
            console.log(res.data.data);
            this.imageCodeUrl = res.data.data.imageCodeUrl;
            this.fileName = res.data.data.fileName;
        },
         //获取浏览器的当前的高度
        getHeight(){
            let _this = this;
            _this.height =  'height:'+document.body.clientHeight+'px';
            window.onresize = function(){
                _this.height =  'height:'+document.body.clientHeight+'px';
            }
        },
        async signIn() {
            let data = await api.loginAdmin(this.signInData);
            if(data.data.code=='200') {
                localStorage.setItem('lianta_accessToken', data.data.data);
                // localStorage.setItem('lianta_userData', JSON.stringify(data.data.data.user));
                // localStorage.setItem('lianta_agentData', JSON.stringify(data.data.data.agent));
                sessionStorage.removeItem('tagItemIndex');
                sessionStorage.removeItem('menuIndex');
                sessionStorage.removeItem('parentMenuIndex');
                this.$router.push({ path:'/main' });
            }
        },
        async captchaButtonClick() {
            if(!isPhoneNumber(this.signInData.phone)){
                this.$message({
                    showClose: true,
                    message: '错了哦，账号不是手机号!',
                    type: 'error'
                });
                return;
            }
            if (this.captchaFont != '获取验证码') return
            console.log('sendCode')

            let res = await api.sendCode({
                Phone:this.signInData.phone,
                ImageCode:this.imageCode,
                FileName:this.fileName,
            });
            console.log(res.data)
            if(res.data.code == '200'){
                this.code = res.data.Msg
                this.countdown();
            }
            
        },
        // 倒计时
        countdown() {
            this.captchaFont = this.totalTime + '秒'
            this.timer = window.setInterval(() => {
            this.totalTime--
            this.rulesText = '验证码已发送'
            if (this.totalTime !== 0) {
                this.captchaFont = this.totalTime + '秒'
            } else {
                this.cleanTimer()
            }
            }, 1000)
        },
        cleanTimer() {
            window.clearInterval(this.timer)
            this.totalTime = 60
            this.captchaFont = '获取验证码'
            this.rulesText = ''
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .login{
        display: flex;
        align-items: center;
        width: 100%;
        height: 100%;
        background-color: #ffffff;
        overflow: hidden;
        position:relative;
        .background{
            position:relative;
            overflow: hidden;
            height: 100%;
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            .backgroundimg{
                overflow: hidden;
                img{
                    width: 100%;
                    // height: 100%;
                    // min-width: 1533px;
                    // min-height: 1000px;
                    min-width: 1500px;
                    // height: 1000px;
                }
            }
            .background-text{
                background-color: #ffffff;
                position: absolute;
                height: 420px;
                color: #000000;
                display: flex;
                font-size: 88px;
                line-height: 110px;
                font-weight: bold;
                border-radius: 5px;
                img{
                    width: 510px;
                    height: 420px;
                }
            }
        }
        .main{
            width: 466px;
            height: 420px;
            display: flex;
            flex-direction: column;
            align-items: center;
            .title{
                line-height: 60px;
                font-size: 32px;
                color: #0e73e8;
                text-align: center;
                font-weight: bold;
                margin-top: 30px;
            }
            .sect{
                // background-color: rgba(255, 255, 255, 0.4);
                border-radius: 10px;
                height: 350px;
                .sect-tit{
                    font-size: 20px;
                    text-align: center;
                    color: #0e73e8;
                    font-weight: bold;
                    letter-spacing:5px;
                    display: flex;
                    justify-content: space-around;
                    line-height: 50px;
                    margin-bottom: 0px;
                    .t-item{
                        color: #ffffff;
                        cursor: pointer;
                    }
                    .t-item-this{
                        color: #0e73e8;
                        border-bottom: 2px solid #1250ea;
                        padding-bottom: 10px;
                        
                    }
                }
                .item{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    line-height: 30px;
                    
                    .item-tit{
                        font-size: 18px;
                        margin-left: 3px;
                    }
                    .input{
                        width: 350px;
                        height: 48px;
                        display: flex;
                        align-items: center;
                    }
                    .item-input{
                        width: 220px;
                        height: 48px;
                        display: flex;
                        align-items: center;
                    }
                    .item-btn{
                        margin-left: 17px;
                    }
                }
                .btn{
                    width: 350px;
                    margin-bottom: 10px;
                    margin-top: 18px;
                    letter-spacing: 1px;
                    font-size: 16px;
                    background-color: #0e73e8;
                    color: #ffffff;
                    font-weight: 500;
                    text-align: center;
                    line-height: 50px;
                    border-radius: 5px;
                    cursor: pointer;
                }
                .btn:hover{
                    opacity: .8;
                }
            }
        }
    }
  
</style>
